import React from "react";

const Concept = () => {
  return (
    <div>
      <p className="step-p">
        If a block is mutated, the block, and subsequent blocks become invalid.
      </p>

      <p className="step-p">
        Invalid blocks are rejected by the peers on the network. They need to be re-mined to be valid.
      </p>

      <p className="step-p">
        Earlier blocks will be harder to corrupt because there are more subsequent invalid blocks to re-mine.
      </p>

      <p className="step-p">
        Because peers on the network are always adding new valid blocks, the hacker
        would have to outmine the network, which requires majority processing power.
      </p>
    </div>
  );
};

export default Concept;



// WEBPACK FOOTER //
// ./src/steps/immutability/concept.js